$(document).ready(function () {
  $('.select-search').select2({
    tags: true,
  });
})
